import NavegacaoConteudo from "@adoo-ui/Organism/NavegacaoConteudo";
import Submenu from "@adoo-ui/Organism/Submenu";
import Layout from "@components/Layout";
import NavegacaoHeaderContent from "@components/ui/Organism/NavegacaoHeaderContent";
import LeftMenu from "@components/LeftMenu";
import React, {useEffect, useState} from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "./Navegacao.scss";
import {useAllDiariosFiltro} from "@context/AllDiariosFiltro";
import {toast} from "react-toastify";

function Navegacao(props) {
  const {
    selecionaPoderEsfera,
    filtro,
    esferasOptions,
    poderesOptions,
    diarios,
    reloadAllDiarios,
    isLoading,
    selecionarDiario,
    setPoderCheckedState,
    esferaCheckedState,
    poderCheckedState,
    updateEsferaCheckedState,
    updatePoderCheckedState,
    handleGetChips,
    handleApplyFilter,
    verifyEsferaCheckedState,
    verifyPoderCheckedState,
    setSearchString,
    searchString,
    handleEnterKeyPress,
    handleClearFiltro,
    showCountExecutivo,
    showCountJudiciario,
    showCountLegislativo,
    showCountMp,
    handleShowMore,
    handleShowLess,
  } = useAllDiariosFiltro();

  const poder = props.match.params.poder;
  const esfera = props.match.params.esfera;

  const [showModal, setShowModal] = useState(false);

  const handleGetDiariosLengthByPoder = (diarioPoder) => {
    const diariosLength = diarios.filter((diario) => diario.poder === diarioPoder);
    return diariosLength.length;
  };

  useEffect(() => {
    reloadAllDiarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro.poder, filtro.esfera]);

  useEffect(() => {
    if (poder && esfera) {
      selecionaPoderEsfera(poder, esfera);
    }
  }, []);

  useEffect(() => {
    verifyEsferaCheckedState();
    if (verifyEsferaCheckedState() === true) {
      toast.error("Selecione pelo menos uma ESFERA para realizar o filtro", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }, [esferaCheckedState]);

  useEffect(() => {
    verifyPoderCheckedState();
    if (verifyPoderCheckedState() === true) {
      toast.error("Selecione pelo menos um PODER para realizar o filtro", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }, [poderCheckedState]);

  return (
    <Layout showContactForm={false}>
      <div className="app-wrapper-interno">
        <Submenu />
        <NavegacaoHeaderContent
          esferasOptions={esferasOptions}
          handleApplyFilter={handleApplyFilter}
          poderesOptions={poderesOptions}
          setShowModal={setShowModal}
          showModal={showModal}
          handleEnterKeyPress={handleEnterKeyPress}
          esferaCheckedState={esferaCheckedState}
          updateEsferaCheckedState={updateEsferaCheckedState}
          poderCheckedState={poderCheckedState}
          setPoderCheckedState={setPoderCheckedState}
          updatePoderCheckedState={updatePoderCheckedState}
          handleGetChips={handleGetChips}
          setSearchString={setSearchString}
          searchString={searchString}
          verifyEsferaCheckedState={verifyEsferaCheckedState}
          verifyPoderCheckedState={verifyPoderCheckedState}
        />

        <Container className="mt-5">
          <Row>
            <Col style={showModal ? {marginTop: 150} : null}>
              <NavegacaoConteudo
                diarios={diarios.filter((diario) =>
                  diario.nome
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .includes(
                      searchString
                        ?.normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                        .toLowerCase()
                    )
                )}
                filtro={filtro}
                isLoading={isLoading}
                handleShowMore={handleShowMore}
                showCountExecutivo={showCountExecutivo}
                showCountJudiciario={showCountJudiciario}
                showCountLegislativo={showCountLegislativo}
                showCountMp={showCountMp}
                selecionarDiario={selecionarDiario}
                handleShowLess={handleShowLess}
                handleGetDiariosLengthByPoder={handleGetDiariosLengthByPoder}
                setSearchString={setSearchString}
                handleClearFiltro={handleClearFiltro}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
}

export default Navegacao;
